import React from 'react'

const initVal = { selectedRoutes: [], selectedBookings: [], staff: [], bookingFilter : {}, productListFilter : [] };

export const BulkActionsContext = React.createContext(initVal);



function bulkActionsReducer(state, action) {
    switch (action.type) {
        case 'setProductFilter': {
            const { productList } = action;
            return {...state, productListFilter : productList };            
        }
        case 'addRouteFilter': {
            const { route } = action;

            if (state.selectedRoutes.find((r) => { return r.id === route.id })) {
                return state
            } else {
                return { ...state, selectedRoutes: [...state.selectedRoutes, route] }
            }

        }
        case 'removeRouteFilter': {
            const { route } = action;

            const newRoutesList = state.selectedRoutes.filter((r) => { return r.id !== route.id })
            return { ...state, selectedRoutes: [...newRoutesList] }

        }
        case 'addBookingSelected': {
            const { booking } = action;

            if (state.selectedBookings.find((r) => { return r.id === booking.id })) {
                return state
            } else {
                return { ...state, selectedBookings: [...state.selectedBookings, booking] }
            }

        }
        case 'removeBookingSelected': {
            const { booking } = action;
            const newBookingList = state.selectedBookings.filter((r) => { return r.id !== booking.id })
            return { ...state, selectedBookings: [...newBookingList] }

        }
        case 'setStaff': {
            const { staff } = action;
            return { ...state, staff }
        }
        case 'setBookingFilter': {
            const { filter } = action;
            return { ...state, bookingFilter : { ...filter}}
        }
        case 'setSelectedBookings': {
            // const { selectedBookingsIdList } = action;
            return state //{ ...state, selectedBookingsIdList }
        }
        default: {
            throw new Error(`Unhandled action type: ${action.type}`)
        }
    }
}

export function BulkActionsProvider({ children }) {
    const [state, dispatch] = React.useReducer(bulkActionsReducer, initVal)
    // NOTE: you *might* need to memoize this value
    // Learn more in http://kcd.im/optimize-context
    const value = { state, dispatch }
    return <BulkActionsContext.Provider value={value}>{children}</BulkActionsContext.Provider>
}



// function useCount() {
//     const context = React.useContext(BulkActionsContext)
//     if (context === undefined) {
//         throw new Error('useCount must be used within a CountProvider')
//     }
//     return context
// }

// function CountConsumer({ children }) {
//     return (
//         <BulkActionsContext.Consumer>
//             {context => {
//                 if (context === undefined) {
//                     throw new Error('CountConsumer must be used within a CountProvider')
//                 }
//                 return children(context)
//             }}
//         </BulkActionsContext.Consumer>
//     )
// }


